// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.product-images img {
  width: 100%;
  height: auto;
}

.products-grid {
  overflow: hidden;
}

@media only screen and (max-width: 1199px) {
  .wrapper-content {
    padding-top: 0;
  }
}

.quantity {
  float: left;
  margin-right: 10px;
}
.quantity input {
  max-width: 50px;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.pdt-title {
  font-family: "Museo-700";
  font-size: 36px;
}
@media only screen and (max-width: 991px) {
  .pdt-title {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  .pdt-title {
    font-size: 24px;
  }
}

@media only screen and (max-width: 991px) {
  .product-main-price {
    font-size: 18px;
  }
}

nav.woocommerce-breadcrumb {
  position: relative;
  padding: 8px 0;
  font-family: "Museo-300";
  max-width: 1260px;
  margin-inline: auto;
}
nav.woocommerce-breadcrumb::before {
  background: #f5f5f5 none repeat scroll 0 0;
  content: "";
  height: 100%;
  left: -270%;
  position: absolute;
  top: 0;
  width: 600%;
  z-index: -9;
  display: block;
}
nav.woocommerce-breadcrumb a {
  color: #767676;
}
@media only screen and (max-width: 767px) {
  nav.woocommerce-breadcrumb a {
    margin-right: 10px;
  }
  nav.woocommerce-breadcrumb a:not(:first-child) {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 767px) {
  nav.woocommerce-breadcrumb span {
    margin-left: 10px;
  }
}

::ng-deep.product-detail .product-images {
  margin: 0;
}
::ng-deep.product-detail .product-images img {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f1f2;
}
::ng-deep.product-detail .pdt-description br {
  display: none;
}

::ng-deep.pdt-description {
  font-family: "Museo-300" !important;
  font-size: 14px;
}

.form-right-thinking select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background-color: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  width: 100%;
  display: inline-block;
  margin-right: 1em;
  margin-top: 5px;
  margin-bottom: 15px;
}

.package-form {
  display: inline-block;
  width: 100%;
  padding-right: 0;
}
.package-form input[type=email] {
  width: 50%;
}
.package-form label,
.package-form select {
  width: 100%;
}
.package-form label {
  line-height: 2em;
  padding: 0 0.75rem 0 0 !important;
  display: block;
}
.package-form label br {
  display: none;
}
.package-form label br.visible {
  display: block;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
}
.package-form select:focus {
  outline: none;
}

.variant-options select {
  width: 50%;
}

.add-cart-section {
  display: inline-block;
  width: 100%;
  padding-top: 10px;
}
.add-cart-section .qty_field {
  max-width: 70px;
  padding: 0px 5px;
  height: 40px;
  /* display: block; */
  margin: 0px 15px 0px 0px;
  text-align: center;
}

.cart-icons {
  float: right;
  text-align: right;
  top: 37px;
  right: 30px;
}
.cart-icons .dropdown-back {
  width: 22px;
  display: inline-block;
  position: relative;
  color: #636363;
}
.cart-icons .basket-item-count {
  position: absolute;
  left: 0;
  top: -12px;
  right: 0;
}

.ibox {
  border: 0 !important;
  box-shadow: none !important;
}
.ibox--noshadow {
  box-shadow: none !important;
  padding: 0;
}
.ibox-content {
  padding: 0;
  border: 0;
}

.cross-sells.custom-cross-sells h2 {
  font-size: 21px;
  padding-top: 15px;
  font-family: "Museo-700";
  color: #636363;
}
.cross-sells.custom-cross-sells ul.products {
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}
.cross-sells.custom-cross-sells ul.products li .ibox {
  border: 1px solid #ddd !important;
  border-radius: 4px !important;
  border-color: #e2e2e2 !important;
}
.cross-sells.custom-cross-sells ul.products li .ibox .ibox-content {
  padding-bottom: 12px;
  height: auto;
}
.cross-sells.custom-cross-sells ul.products li .ibox .ibox-content .product-imitation {
  padding: 10px;
}
.cross-sells.custom-cross-sells ul.products li .ibox .ibox-content .product-desc {
  padding: 10px;
}
.cross-sells.custom-cross-sells ul.products li h2.woocommerce-loop-product__title {
  color: #636363;
  font-size: 14px !important;
  font-family: "Museo-300" !important;
  padding: 0;
  margin: 0;
  min-height: 48px;
}
.cross-sells.custom-cross-sells ul.products li .thumbnail {
  border: 0;
}
.cross-sells.custom-cross-sells ul.products li .thumbnail img {
  height: 220px;
  width: auto;
}
.cross-sells.custom-cross-sells ul.products li .price-btn-cstm {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cross-sells.custom-cross-sells ul.products li span.price {
  display: block;
  font-weight: 400;
  margin-bottom: 0.5em;
  font-size: 0.857em;
  color: #636363;
}

::ng-deep.certification-link {
  color: #676a6c !important;
  text-decoration: underline;
}

::ng-deep.toolset-learner-kit {
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
}
::ng-deep.toolset-learner-kit th {
  position: relative;
  border: 0 !important;
}
::ng-deep.toolset-learner-kit th code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep.toolset-learner-kit th:not(:first-child) {
  text-align: center;
}
::ng-deep.toolset-learner-kit th em {
  font-style: normal;
  position: absolute;
  right: -6px;
}
::ng-deep.toolset-learner-kit tr td:not(:first-child) {
  text-align: center;
}
::ng-deep.toolset-learner-kit tr td:not(:first-child) code {
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #676a6c !important;
  font-size: 1em !important;
}
::ng-deep.toolset-learner-kit tr:last-child td {
  background: #fff;
  border: 0 !important;
}

.f-p-top-0 {
  padding-top: 0 !important;
}

.wrapper-content .cont {
  padding-inline: 15px;
  margin-inline: auto;
}
@media screen and (min-width: 768px) {
  .wrapper-content .cont {
    width: 750px;
  }
}
@media screen and (min-width: 992px) {
  .wrapper-content .cont {
    width: 970px;
  }
}
@media screen and (min-width: 1400px) {
  .wrapper-content .cont {
    width: 1350px;
  }
}
@media screen and (min-width: 1600px) {
  .wrapper-content .cont {
    width: 1570px;
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1850px) {
  .wrapper-content .cont {
    width: 1300px;
    padding-inline: 15px;
  }
}
@media screen and (max-width: 1440px) {
  .wrapper-content .cont {
    width: 100%;
  }
}
@media screen and (max-width: 991px) {
  .wrapper-content .cont .profile-text {
    width: 100%;
  }
}
@media screen and (max-width: 1199px) {
  .wrapper-content .cont .prdct {
    width: 33.3333%;
  }
}
@media screen and (max-width: 991px) {
  .wrapper-content .cont .prdct {
    width: 50%;
  }
}
@media screen and (max-width: 767px) {
  .wrapper-content .cont .prdct {
    width: 100%;
  }
}
.wrapper-content .cont form.fs-tp-frm label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
.wrapper-content .cont form.fs-tp-qform .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
@media only screen and (max-width: 1199px) {
  .wrapper-content .cont .prd-lst__itm {
    width: 33%;
  }
}
@media only screen and (max-width: 991px) {
  .wrapper-content .cont .prd-lst__itm {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .wrapper-content .cont .prd-lst__itm {
    width: 100%;
  }
}

.product-section {
  padding: 60px 0 56px !important;
}
@media (max-width: 767px) {
  .product-section {
    padding: 40px 0 56px !important;
  }
}
.product-section-pdt {
  padding-top: 0 !important;
}
.product-section .container {
  max-width: 1260px;
  margin-inline: auto;
}
@media (max-width: 480px) {
  .product-section .prd-pic {
    margin-bottom: 30px;
  }
}
.product-section ::ng-deep.prd-cnt {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.product-section ::ng-deep.prd-cnt .title {
  font-size: 48px;
  font-family: "Museo-regular";
  color: #666;
  line-height: 104.167%;
  margin: 0;
}
@media (max-width: 480px) {
  .product-section ::ng-deep.prd-cnt .title {
    font-size: 36px;
  }
}
.product-section ::ng-deep.prd-cnt .price {
  display: block;
  width: 100%;
  font-size: 24px;
  font-family: "Museo-regular";
  line-height: 125%;
  color: #666;
}
.product-section ::ng-deep.prd-cnt p, .product-section ::ng-deep.prd-cnt li {
  font-size: 18px;
  font-weight: 400;
  font-family: "MuseoSans-300";
  color: #666;
  line-height: 166.667%;
}
.product-section ::ng-deep.prd-cnt p a, .product-section ::ng-deep.prd-cnt li a {
  font-family: "MuseoSans-300";
  color: #666;
  text-decoration: underline;
}
@media (max-width: 480px) {
  .product-section ::ng-deep.prd-cnt p, .product-section ::ng-deep.prd-cnt li {
    font-size: 16px;
  }
}
.product-section ::ng-deep.prd-cnt .prd__buy-btn {
  min-width: 214px;
  align-items: center;
  background-color: #69be28;
  border: 1px solid #69be28;
  border-radius: 3px;
  color: #fff;
  display: inline-flex;
  flex-wrap: wrap;
  font-family: "Museo-regular";
  font-size: 16px;
  justify-content: center;
  line-height: 26px;
  min-width: 172px;
  padding: 6px 24px;
  text-align: center;
  text-decoration: none;
  transition: 0.3s;
}
.product-section ::ng-deep.prd-cnt .prd__buy-btn:hover {
  background-color: #00add0;
  border-color: #00add0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-product-details/public-product-details.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YE;EACE,WAAA;EACA,YAAA;AA+YJ;;AA3YA;EACE,gBAAA;AA8YF;;AA1YE;EADF;IAEI,cAAA;EA8YF;AACF;;AA3YA;EACE,WAAA;EACA,kBAAA;AA8YF;AA5YE;EACE,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AA8YJ;;AA1YA;EACE,wBAAA;EACA,eAAA;AA6YF;AA3YE;EAJF;IAKI,eAAA;EA8YF;AACF;AA5YE;EARF;IASI,eAAA;EA+YF;AACF;;AA3YE;EADF;IAEI,eAAA;EA+YF;AACF;;AA5YA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;AA+YF;AA7YE;EACE,0CAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AA+YJ;AA5YE;EACE,cAAA;AA8YJ;AA5YI;EAHF;IAII,kBAAA;EA+YJ;EA7YI;IACE,iBAAA;EA+YN;AACF;AA1YI;EADF;IAEI,iBAAA;EA6YJ;AACF;;AAnYE;EAEE,SAAA;AAqYJ;AAnYI;EACE,wCAAA;EACA,yBAAA;AAqYN;AAjYE;EACI,aAAA;AAmYN;;AA/XA;EACE,mCAAA;EACA,eAAA;AAkYF;;AA9XE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAiYJ;;AA7XA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;AAgYF;AA9XE;EACE,UAAA;AAgYJ;AA7XE;;EAEE,WAAA;AA+XJ;AA5XE;EACE,gBAAA;EACA,iCAAA;EACA,cAAA;AA8XJ;AA5XI;EACE,aAAA;AA8XN;AA5XM;EACE,cAAA;AA8XR;AAzXE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AA2XJ;AAxXE;EACE,aAAA;AA0XJ;;AArXE;EACE,UAAA;AAwXJ;;AApXA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;AAuXF;AArXE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AAuXJ;;AAnXA;EACE,YAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAsXF;AApXE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAsXJ;AAnXE;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;AAqXJ;;AAjXA;EACE,oBAAA;EACA,2BAAA;AAoXF;AAlXE;EACE,2BAAA;EACA,UAAA;AAoXJ;AAjXE;EACE,UAAA;EACA,SAAA;AAmXJ;;AA9WE;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AAiXJ;AA9WE;EACE,UAAA;EAYA,cAAA;EACA,eAAA;AAqWJ;AA7VM;EACE,iCAAA;EACA,6BAAA;EACA,gCAAA;AA+VR;AA7VQ;EACE,oBAAA;EACA,YAAA;AA+VV;AA7VU;EACE,aAAA;AA+VZ;AA5VU;EACE,aAAA;AA8VZ;AAzVM;EACE,cAAA;EACA,0BAAA;EACA,mCAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AA2VR;AAxVM;EACE,SAAA;AA0VR;AAxVQ;EACE,aAAA;EACA,WAAA;AA0VV;AAtVM;EAIE,aAAA;EACA,8BAAA;EACA,mBAAA;AAwVR;AArVM;EACE,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAuVR;;AAlUA;EACE,yBAAA;EACA,0BAAA;AAqUF;;AAlUA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAqUF;AAnUE;EACE,kBAAA;EACA,oBAAA;AAqUJ;AAnUI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AAqUN;AAlUI;EACE,kBAAA;AAoUN;AAjUI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAmUN;AA/TE;EACE,kBAAA;AAiUJ;AA/TI;EACE,iCAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;AAiUN;AA7TE;EACE,gBAAA;EACA,oBAAA;AA+TJ;;AAvTA;EACE,yBAAA;AA0TF;;AAtTE;EACE,oBAAA;EACA,mBAAA;AAyTJ;AAtTI;EALF;IAMI,YAAA;EAyTJ;AACF;AAvTI;EATF;IAUI,YAAA;EA0TJ;AACF;AAxTI;EAbF;IAcI,aAAA;EA2TJ;AACF;AAzTI;EAjBF;IAkBI,aAAA;IACA,oBAAA;EA4TJ;AACF;AA1TI;EAtBF;IAuBI,aAAA;IACA,oBAAA;EA6TJ;AACF;AA3TI;EA3BF;IA4BI,WAAA;EA8TJ;AACF;AA3TM;EADF;IAEI,WAAA;EA8TN;AACF;AA1TM;EADF;IAEI,eAAA;EA6TN;AACF;AA3TM;EALF;IAMI,UAAA;EA8TN;AACF;AA5TM;EATF;IAUI,WAAA;EA+TN;AACF;AA3TM;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA6TR;AAxTM;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AA0TR;AApTQ;EADF;IAEI,UAAA;EAuTR;AACF;AArTQ;EALF;IAMI,UAAA;EAwTR;AACF;AAtTQ;EATF;IAUI,WAAA;EAyTR;AACF;;AAnTA;EACE,+BAAA;AAsTF;AApTE;EAHF;IAII,+BAAA;EAuTF;AACF;AArTE;EACE,yBAAA;AAuTJ;AApTE;EACE,iBAAA;EACA,mBAAA;AAsTJ;AAlTI;EADF;IAEI,mBAAA;EAqTJ;AACF;AAlTE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAoTJ;AAlTI;EACE,eAAA;EACA,4BDpfK;ECqfL,WAAA;EACA,qBAAA;EACA,SAAA;AAoTN;AAlTM;EAPF;IAQI,eAAA;EAqTN;AACF;AAlTI;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,4BDlgBK;ECmgBL,iBAAA;EACA,WAAA;AAoTN;AAjTI;EACE,eAAA;EACA,gBAAA;EACA,4BDvgBM;ECwgBN,WAAA;EACA,qBAAA;AAmTN;AAjTM;EACE,4BD5gBI;EC6gBJ,WAAA;EACA,0BAAA;AAmTR;AAhTM;EAbF;IAcI,eAAA;EAmTN;AACF;AAhTI;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,4BDliBK;ECmiBL,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAkTN;AAhTM;EACE,yBAAA;EACA,qBAAA;AAkTR","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n.product-images {\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.products-grid {\n  overflow: hidden;\n}\n\n.wrapper-content {\n  @media #{$pc} {\n    padding-top: 0;\n  }\n}\n\n.quantity {\n  float: left;\n  margin-right: 10px;\n\n  input {\n    max-width: 50px;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n}\n\n.pdt-title {\n  font-family: 'Museo-700';\n  font-size: 36px;\n\n  @media #{$tablet} {\n    font-size: 28px;\n  }\n\n  @media #{$mobile} {\n    font-size: 24px;\n  }\n}\n\n.product-main-price {\n  @media #{$tablet} {\n    font-size: 18px;\n  }\n}\n\nnav.woocommerce-breadcrumb {\n  position: relative;\n  padding: 8px 0;\n  font-family: 'Museo-300';\n  max-width: 1260px;\n  margin-inline: auto;\n\n  &::before {\n    background: #f5f5f5 none repeat scroll 0 0;\n    content: \"\";\n    height: 100%;\n    left: -270%;\n    position: absolute;\n    top: 0;\n    width: 600%;\n    z-index: -9;\n    display: block;\n  }\n\n  a {\n    color: #767676;\n\n    @media only screen and (max-width: 767px) {\n      margin-right: 10px;\n\n      &:not(:first-child) {\n        margin-left: 10px;\n      }\n    }\n  }\n\n  span {\n    @media only screen and (max-width: 767px) {\n      margin-left: 10px;\n    }\n  }\n}\n\n// .product-detail .ibox-content {\n//   padding-top: 40px;\n// }\n\n::ng-deep.product-detail {\n\n  .product-images {\n\n    margin: 0;\n\n    img {\n      box-shadow: 0 0 20px rgba(0,0,0,0.05);\n      border: 1px solid $color-neutral-light;\n    }\n  } \n\n  .pdt-description br {\n      display: none;\n  }\n}\n\n::ng-deep.pdt-description {\n  font-family: 'Museo-300' !important;\n  font-size: 14px;\n}\n\n.form-right-thinking {\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background-color: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    width: 100%;\n    display: inline-block;\n    margin-right: 1em;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n.package-form {\n  display: inline-block;\n  width: 100%;\n  padding-right: 0;\n\n  input[type=\"email\"] {\n    width: 50%;\n  }\n\n  label,\n  select {\n    width: 100%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: 0 .75rem 0 0 !important;\n    display: block;\n\n    br {\n      display: none;\n\n      &.visible {\n        display: block;\n      }\n    }\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    margin-bottom: 10px;\n  }\n\n  select:focus {\n    outline: none;\n  }\n}\n\n.variant-options {\n  select {\n    width: 50%;\n  }\n}\n\n.add-cart-section {\n  display: inline-block;\n  width: 100%;\n  padding-top: 10px;\n\n  .qty_field{\n    max-width: 70px;\n    padding: 0px 5px;\n    height: 40px;\n    /* display: block; */\n    margin: 0px 15px 0px 0px;\n    text-align: center;\n  }\n}\n\n.cart-icons {\n  float: right;\n  text-align: right;\n  top: 37px;\n  right: 30px;\n\n  .dropdown-back {\n    width: 22px;\n    display: inline-block;\n    position: relative;\n    color: #636363;\n  }\n\n  .basket-item-count {\n    position: absolute;\n    left: 0;\n    top: -12px;\n    right: 0;\n  }\n}\n\n.ibox {\n  border: 0 !important;\n  box-shadow: none !important;\n\n  &--noshadow {\n    box-shadow: none !important;\n    padding: 0;\n  }\n\n  &-content {\n    padding: 0;\n    border: 0;\n  }\n}\n\n.cross-sells.custom-cross-sells {\n  h2 {\n    font-size: 21px;\n    padding-top: 15px;\n    font-family: 'Museo-700';\n    color: #636363;\n  }\n\n  ul.products {\n    padding: 0;\n    // list-style: none outside;\n    // clear: both;\n    // margin-left: -10px;\n    // margin-right: -10px;\n    // padding-left: 5px;\n    // padding-right: 5px;\n    // display: -webkit-box;\n    // display: -ms-flexbox;\n    // display: flex;\n    // -ms-flex-wrap: wrap;\n    // flex-wrap: wrap;\n    margin-left: 0;\n    margin-right: 0;\n\n    li {\n      // padding: 10px;\n      // border: 1px solid #ddd;\n      // margin: .5%;\n      // width: 19%;\n\n      .ibox {\n        border: 1px solid #ddd !important;\n        border-radius: 4px !important;\n        border-color: #e2e2e2 !important;\n\n        .ibox-content {\n          padding-bottom: 12px;\n          height: auto;\n\n          .product-imitation {\n            padding: 10px;\n          }\n  \n          .product-desc {\n            padding: 10px;\n          }\n        }       \n      }\n\n      h2.woocommerce-loop-product__title {\n        color: #636363;\n        font-size: 14px !important;\n        font-family: 'Museo-300' !important;\n        padding: 0;\n        margin: 0;\n        min-height: 48px;\n      }\n\n      .thumbnail {\n        border: 0;\n\n        img {\n          height: 220px;\n          width: auto;\n        }\n      }\n\n      .price-btn-cstm {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      span.price {\n        display: block;\n        font-weight: 400;\n        margin-bottom: .5em;\n        font-size: .857em;\n        color: #636363;\n      }\n\n      // .add_to_cart_button {\n      //   background: #7BBC43;\n      //   font-family: 'Museo-300';\n      //   font-size: 14px;\n      //   padding: 7px;\n      //   color: #fff;\n      //   font-weight: 400;\n      //   border-radius: 0;\n\n      //   &:hover {\n      //     opacity: .9;\n      //     color: #fff;\n      //   }\n      // }\n    }\n  }\n}\n\n::ng-deep.certification-link {\n  color: #676a6c !important;\n  text-decoration: underline;\n}\n\n::ng-deep.toolset-learner-kit {\n  border-bottom: 0;\n  border-left: 0;\n  border-right: 0;\n\n  th {\n    position: relative;\n    border: 0 !important;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: #676a6c !important;\n      font-size: 1em !important;\n    }\n\n    &:not(:first-child) {\n      text-align: center;\n    }\n\n    em {\n      font-style: normal;\n      position: absolute;\n      right: -6px;\n    }\n  }\n\n  tr td:not(:first-child) {\n    text-align: center;\n\n    code {\n      background-color: #fff !important;\n      border-radius: 0 !important;\n      color: #676a6c !important;\n      font-size: 1em !important;\n    }\n  }\n\n  tr:last-child td {\n    background: #fff;\n    border: 0 !important;\n  }\n}\n\n// .wrapper-top {\n//   margin-block-start: 133px;\n// }\n\n.f-p-top-0 {\n  padding-top: 0 !important;\n}\n\n.wrapper-content {\n  .cont {\n    padding-inline: 15px;\n    margin-inline: auto;\n    \n\n    @media screen and (min-width: 768px) {\n      width: 750px;\n    }\n\n    @media screen and (min-width: 992px) {\n      width: 970px;\n    }    \n\n    @media screen and (min-width: 1400px) {\n      width: 1350px;\n    }\n\n    @media screen and (min-width: 1600px) {\n      width: 1570px;\n      padding-inline: 20px;\n    }\n\n    @media screen and (max-width: 1850px) {\n      width: 1300px;\n      padding-inline: 15px;\n    }\n\n    @media screen and (max-width: 1440px) {\n      width: 100%;\n    }\n\n    .profile-text {\n      @media screen and (max-width: 991px) {\n        width: 100%;\n      }\n    }\n\n    .prdct {\n      @media screen and (max-width: 1199px) {\n        width: 33.3333%;\n      }\n\n      @media screen and (max-width: 991px) {\n        width: 50%;\n      }\n\n      @media screen and (max-width: 767px) {\n        width: 100%;\n      }\n    }\n\n    form.fs-tp-frm {\n      label {\n        display: inline-block;\n        max-width: 100%;\n        margin-bottom: 5px;\n        font-weight: 700;\n      }\n    }\n\n    form.fs-tp-qform {\n      .btn-group {\n        position: relative;\n        display: inline-block;\n        vertical-align: middle;\n      }\n    }\n\n    .prd-lst {\n      &__itm {\n        @media #{$pc} {\n          width: 33%;\n        }\n\n        @media #{$tablet} {\n          width: 50%;\n        }\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.product-section{\n  padding: 60px 0 56px !important;\n\n  @media (max-width: 767px){\n    padding: 40px 0 56px !important;\n  }\n\n  &-pdt {\n    padding-top: 0 !important;\n  }\n\n  .container{\n    max-width: 1260px;\n    margin-inline: auto;\n  }\n\n  .prd-pic{\n    @media (max-width: 480px){\n      margin-bottom: 30px;\n    }\n  }\n\n  ::ng-deep.prd-cnt{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n\n    .title{\n      font-size: 48px;\n      font-family: $muso-500;\n      color: #666;\n      line-height: 104.167%;\n      margin: 0;\n\n      @media (max-width: 480px){\n        font-size: 36px;\n      }\n    }\n\n    .price{\n      display: block;\n      width: 100%;\n      font-size: 24px;\n      font-family: $muso-500;\n      line-height: 125%;\n      color: #666;\n    }\n\n    p,li{\n      font-size: 18px;\n      font-weight: 400;\n      font-family: $muso-sans;\n      color: #666;\n      line-height: 166.667%;\n\n      a{\n        font-family: $muso-sans;\n        color: #666;\n        text-decoration: underline;\n      }\n\n      @media (max-width: 480px){\n        font-size: 16px;\n      }\n    }\n\n    .prd__buy-btn{\n      min-width: 214px;\n      align-items: center;\n      background-color: #69be28;\n      border: 1px solid #69be28;\n      border-radius: 3px;\n      color: #fff;\n      display: inline-flex;\n      flex-wrap: wrap;\n      font-family: $muso-500;\n      font-size: 16px;\n      justify-content: center;\n      line-height: 26px;\n      min-width: 172px;\n      padding: 6px 24px;\n      text-align: center;\n      text-decoration: none;\n      transition: 0.3s;\n\n      &:hover{\n        background-color: #00add0;\n        border-color: #00add0;\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
